import React from "react";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import Lottie from "react-lottie";

interface LottieAnimationProps {
  type?: "json" | "lottie";
  lottieUrl?: string;
  jsonData?: JSON;
  width?: string;
  height?: string;
}

const LottieAnimation: React.FC<LottieAnimationProps> = ({
  type = "lottie",
  lottieUrl,
  jsonData,
  width = "100%",
  height = "400px",
}) => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: jsonData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  return (
    <>
      {type === "json" ? (
        <Lottie options={defaultOptions} width={width} height={height} />
      ) : (
        <DotLottieReact
          src={lottieUrl}
          loop
          autoplay
          style={{ width, height }}
        />
      )}
    </>
  );
};

export default LottieAnimation;
